import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../../../helpers/api';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';

const commentsListApi = new Api('orientations/sessions/:id/messages');

function* loadData(data) {
  try {
    const { id, pageSize } = data.payload;
    const result = yield call(
      sendRequest,
      commentsListApi.load,
      { id, search: { pageSize } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortable_columns } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: records,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
